import { openBlock as e, createElementBlock as t, createElementVNode as o } from "vue";
const c = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, n = /* @__PURE__ */ o("path", { d: "M12 2.071c-5.477 0-9.929 4.452-9.929 9.929S6.523 21.929 12 21.929s9.929-4.452 9.929-9.929S17.477 2.071 12 2.071Zm0 1.386a8.46 8.46 0 0 1 5.523 2.04L5.498 17.524A8.507 8.507 0 0 1 3.457 12c0-4.71 3.833-8.543 8.543-8.543Zm0 17.086a8.459 8.459 0 0 1-5.523-2.04L18.502 6.476A8.507 8.507 0 0 1 20.543 12c0 4.71-3.833 8.543-8.543 8.543Z" }, null, -1), r = [
  n
];
function s(a, l) {
  return e(), t("svg", c, [...r]);
}
const _ = { render: s };
export {
  _ as default,
  s as render
};
